document.addEventListener('DOMContentLoaded', function () {

    const coursesFilterWrapper = document.getElementById('coursesFilterWrapper');
    if (!coursesFilterWrapper) return;

    const courses = document.querySelectorAll('.course-item');
    const tabButtons = document.querySelectorAll('.courses-filter__tab');
    const filterPanels = document.querySelectorAll('.filer-items-tab');

    const activeFilters = {
        type: 'all',
        country: null,
        lecturer: null,
        year: null,
        months: [],
    };

    // Tab button clicks
    tabButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            const type = btn.dataset.filterType;

            if (['country', 'lecturer', 'date'].includes(type)) {
                const panel = document.querySelector(`.filer-items-tab[data-filter-type="${type}"]`);
                const isOpen = panel.classList.contains('is-open');
                filterPanels.forEach(p => p.classList.remove('is-open'));
                document.querySelectorAll('.courses-filter__tab[data-filter-type="country"], .courses-filter__tab[data-filter-type="lecturer"]').forEach(b => b.classList.remove('is-active'));
                if (!isOpen) {
                    panel.classList.add('is-open');
                    btn.classList.add('is-active');
                }
            } else {
                filterPanels.forEach(p => p.classList.remove('is-open'));
                activeFilters.type = type;
                document.querySelectorAll('.courses-filter__tab[data-filter-type="all"], .courses-filter__tab[data-filter-type="live"], .courses-filter__tab[data-filter-type="webinar"]').forEach(b => b.classList.remove('is-active'));
                btn.classList.add('is-active');
                applyFilters();
            }
        });
    });

    // Checkbox changes
    document.querySelectorAll('input[data-filter]').forEach(input => {
        input.addEventListener('change', () => {
            const filter = input.dataset.filter;
            const value = input.value;

            if (filter === 'country') {
                document.querySelectorAll('input[data-filter="country"]').forEach(i => {
                    if (i !== input) i.checked = false;
                });
                // Prevent unchecking
                if (!input.checked) input.checked = true;
                activeFilters.country = value === 'All' ? null : value;

                // Active class on button
                const btn = document.querySelector('.courses-filter__tab[data-filter-type="country"]');
                btn.classList.toggle('is-active', value !== 'All');
            }

            if (filter === 'lecturer') {
                document.querySelectorAll('input[data-filter="lecturer"]').forEach(i => {
                    if (i !== input) i.checked = false;
                });
                if (!input.checked) input.checked = true;
                activeFilters.lecturer = value === 'All' ? null : value;

                const btn = document.querySelector('.courses-filter__tab[data-filter-type="lecturer"]');
                btn.classList.toggle('is-active', value !== 'All');
            }

            applyFilters();
        });
    });

    function applyFilters() {
        courses.forEach(course => {
            let visible = true;

            // Type filter (live/webinar)
            if (activeFilters.type !== 'all') {
                const courseType = course.dataset.filterType;
                if (courseType !== activeFilters.type) visible = false;
            }

            // Country filter
            if (activeFilters.country) {
                const courseCountries = course.dataset.filterCountry
                    ? course.dataset.filterCountry.split('|')
                    : [];
                if (!courseCountries.includes(activeFilters.country)) visible = false;
            }

            // Lecturer filter
            if (activeFilters.lecturer) {
                const courseLecturers = course.dataset.filterInstructors
                    ? course.dataset.filterInstructors.split('|')
                    : [];
                if (!courseLecturers.includes(activeFilters.lecturer)) visible = false;
            }

            // Date filter
            if (activeFilters.year) {
                const start = course.dataset.filterDateStart;
                const end = course.dataset.filterDateEnd;

                if (!start || !end) {
                    visible = false;
                } else {
                    const startDate = new Date(start);
                    const endDate = new Date(end);
                    const selectedYear = activeFilters.year;

                    if (selectedYear < startDate.getFullYear() || selectedYear > endDate.getFullYear()) {
                        visible = false;
                    } else if (activeFilters.months.length > 0) {
                        const hasMonth = activeFilters.months.some(month => {
                            const monthStart = new Date(selectedYear, month, 1);
                            const monthEnd = new Date(selectedYear, month + 1, 0);
                            return monthEnd >= startDate && monthStart <= endDate;
                        });
                        if (!hasMonth) visible = false;
                    }
                }
            }

            course.style.display = visible ? '' : 'none';
        });
    }

    // Close panels on outside click
    document.addEventListener('click', e => {
        if (!e.target.closest('#coursesFilterWrapper')) {
            filterPanels.forEach(p => p.classList.remove('is-open'));
        }
    });

    // Year buttons
    document.querySelectorAll('.filter-year-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const year = parseInt(btn.dataset.year);
            const isActive = btn.classList.contains('is-active');

            document.querySelectorAll('.filter-year-btn').forEach(b => b.classList.remove('is-active'));
            document.querySelectorAll('input[data-filter="month"]').forEach(i => {
                i.checked = false;
                i.closest('label').classList.remove('is-active');
            });
            activeFilters.months = [];

            if (!isActive) {
                btn.classList.add('is-active');
                activeFilters.year = year;
            } else {
                activeFilters.year = null;
            }

            const dateBtn = document.querySelector('.courses-filter__tab[data-filter-type="date"]');
            dateBtn.classList.toggle('is-active', activeFilters.year !== null);

            applyFilters();
        });
    });

// Month checkboxes
    document.querySelectorAll('input[data-filter="month"]').forEach(input => {
        input.addEventListener('change', () => {
            if (!activeFilters.year) return; // year must be selected first
            const month = parseInt(input.value);
            input.closest('label').classList.toggle('is-active', input.checked);
            if (input.checked) {
                activeFilters.months.push(month);
            } else {
                activeFilters.months = activeFilters.months.filter(m => m !== month);
            }
            applyFilters();
        });
    });
});